import { get } from "../../service/api";

// =============================================================================
// Merchant-side service — зөвхөн харах (READ-ONLY)
// Тохиргоо засуулах эрх админ талд байна.
// =============================================================================

export const ListMyFeeShareRules = async () => {
  try {
    return await get(`/feeShareRule/my`);
  } catch (error) {
    console.error("Error ListMyFeeShareRules:", error);
    throw error;
  }
};

export const ListMyTransactionFeeShares = async (query) => {
  try {
    return await get(`/feeShareRule/my/shares?${query}`);
  } catch (error) {
    console.error("Error ListMyTransactionFeeShares:", error);
    throw error;
  }
};
